import { useState, useEffect } from "react"
import Sheet from 'react-modal-sheet';

export default function DashboardDefaultViewModal(
    { 
        isDashboardDefaultViewModalOpen,
        onDashboardDefaultViewSaveClick,
        onDashboardDefaultViewModalDismiss,
        initialStatus
    }
) {

    const [viewType, setViewType] = useState(initialStatus)

    useEffect(() => {
        setViewType(initialStatus)
    }, [initialStatus])

    function onStatusChange(status) {
        console.log(`onStatusChange ${status}`)
        setViewType(status)
    }

    return <Sheet
     isOpen={isDashboardDefaultViewModalOpen} onClose={() => {onDashboardDefaultViewModalDismiss()}} onOpenEnd={() => {}} detent="conten-height"
     >
        <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content className="bg-base-300">
        <Sheet.Scroller draggableAt="both">
        <div className="p-4 h-full">
        <div className="pb-8 px-4">
            <div className="font-bold text-lg pb-2 flex items-center font-titan">
                <span>Map live status</span>
            </div>
            <div className="flex flex-row w-full gap-2">
            <button className={`btn btn-primary mr-2 normal-case ${viewType === "LIST" ? "" : "btn-outline"}`} onClick={
                    () => {
                        onStatusChange("LIST")
                    }
                    } >
                    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className={`hover:stroke-primary-content ${viewType === "LIST" ? "stroke-primary-content" : "stroke-primary"}`} d="M8 6.00067L21 6.00139M8 12.0007L21 12.0015M8 18.0007L21 18.0015M3.5 6H3.51M3.5 12H3.51M3.5 18H3.51M4 6C4 6.27614 3.77614 6.5 3.5 6.5C3.22386 6.5 3 6.27614 3 6C3 5.72386 3.22386 5.5 3.5 5.5C3.77614 5.5 4 5.72386 4 6ZM4 12C4 12.2761 3.77614 12.5 3.5 12.5C3.22386 12.5 3 12.2761 3 12C3 11.7239 3.22386 11.5 3.5 11.5C3.77614 11.5 4 11.7239 4 12ZM4 18C4 18.2761 3.77614 18.5 3.5 18.5C3.22386 18.5 3 18.2761 3 18C3 17.7239 3.22386 17.5 3.5 17.5C3.77614 17.5 4 17.7239 4 18Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>  
                    List
                </button>
                <button className={`btn btn-primary mr-2 normal-case ${viewType === "MAP" ? "" : "btn-outline"}`} onClick={
                    () => {
                        onStatusChange("MAP")
                    }
                    } >
                    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className={`hover:stroke-primary-content ${viewType === "MAP" ? "stroke-primary-content" : "stroke-primary"}`} d="M9 20L3 17V4L9 7M9 20L15 17M9 20V7M15 17L21 20V7L15 4M15 17V4M9 7L15 4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>   
                    Map
                </button>
            </div>
        </div>
        <div className="modal-action bg-base-100 w-full px-4 py-4">
            <button className="btn btn-success text-success-content mr-2 normal-case" onClick={
                () => {
                    onDashboardDefaultViewSaveClick(viewType)
                }
                } >
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className="stroke-success-content" d="M8 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H9M8 20V14C8 13.4477 8.44772 13 9 13H15C15.5523 13 16 13.4477 16 14V20M8 20H16M16 20H18C19.1046 20 20 19.1046 20 18V8.82843C20 8.29799 19.7893 7.78929 19.4142 7.41421L16.5858 4.58579C16.2107 4.21071 15.702 4 15.1716 4H15M15 4V7C15 7.55228 14.5523 8 14 8H10C9.44772 8 9 7.55228 9 7V4M15 4H9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>    
                Save
            </button>

            <button className="btn btn-circle btn-soft" onClick={
                    () => {
                        onDashboardDefaultViewModalDismiss()
                    }
                    }>
                <svg className="fill-base-content w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.207 6.207a1 1 0 0 0-1.414-1.414L12 10.586 6.207 4.793a1 1 0 0 0-1.414 1.414L10.586 12l-5.793 5.793a1 1 0 1 0 1.414 1.414L12 13.414l5.793 5.793a1 1 0 0 0 1.414-1.414L13.414 12l5.793-5.793z"/></svg>
            </button>
        </div>
        </div>
        </Sheet.Scroller>
        </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={(_) => {
            onDashboardDefaultViewModalDismiss()
        }}/>
    </Sheet>
}